/* eslint-disable camelcase */

import { makeObservable, observable, override } from 'mobx'
import Address from './Address'
import ClientsAddressesEquipment from './ClientsAddressesEquipment'
import Model from './Model'

class ClientsAddress extends Model {
  @observable id = 0
  @observable address_id = 0
  @observable client_id = 0
  @observable clients_synced_id = 0

  /**
   *
   * @type {Address}
   */
  @observable address = null

  /**
   *
   * @type {Array<ClientsAddressesEquipment>}
   */
  @observable clients_addresses_equipments = []

  @observable status = null
  @observable created = null
  @observable modified = null

  constructor () {
    super()
    makeObservable(this)
  }

  @override
  setData (data) {
    const { address, clients_addresses_equipments, ...rest } = data
    if (address) {
      this.address = new Address()
      this.address.setOriginalData(address)
    }
    if (clients_addresses_equipments) {
      for (const clientsAddressesEquipment of data.clients_addresses_equipments) {
        const clientsAddressEquipment = new ClientsAddressesEquipment()
        clientsAddressEquipment.setOriginalData(clientsAddressesEquipment)
        this.clients_addresses_equipments.push(clientsAddressEquipment)
      }
    }
    super.setData(rest)
  }
}

export default ClientsAddress
